import React from 'react'

const RecentTransacton = () => {
    return (
        <>
            <div className='space-y-3 relative'>
                <div className='c-center-absolute z-10'>
                    
                    <div className='flex justify-center'>
                        <img src="/images/cuate.svg" alt="alt-img" />
                    </div>
                    <div className='py-2'>
                       <p className='text-black text-center font-bold text-gray-600'>No Transactions Yet!</p>
                    </div>
                </div>
                <div className='py-2 border-gray-200 opacity-50'>
                    <div className='w-[95%] mx-auto space-y-4 justify-between items-center'>
                        <div className='flex justify-between items-center'>
                            <div className='space-y-2'>
                                <div className='bg-gray-200 h-4 w-20'>
                                </div>
                                <div className='bg-gray-200 h-4 w-8'>
                                </div>
                            </div>
                            <div className='space-y-2'>
                                <div className='bg-gray-200 h-4 w-32'>
                                </div>
                            </div>
                            <div className='space-y-2 flex-col flex'>
                                <div className='bg-gray-200 h-4 w-20'>
                                </div>
                                <div className='bg-gray-200 h-4  w-8 self-end'>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='py-2 bg-gray-100 border-gray-200 opacity-50'>
                    <div className='w-[95%] mx-auto space-y-4 justify-between items-center'>
                        <div className='flex justify-between items-center'>
                            <div className='space-y-2'>
                                <div className='bg-gray-200 h-4 w-20'>
                                </div>
                                <div className='bg-gray-200 h-4 w-8'>
                                </div>
                            </div>
                            <div className='space-y-2'>
                                <div className='bg-gray-200 h-4 w-32'>
                                </div>
                            </div>
                            <div className='space-y-2 flex-col flex'>
                                <div className='bg-gray-200 h-4 w-20'>
                                </div>
                                <div className='bg-gray-200 h-4  w-8 self-end'>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='py-2 border-gray-200 opacity-50'>
                    <div className='w-[95%] mx-auto space-y-4 justify-between items-center'>
                        <div className='flex justify-between items-center'>
                            <div className='space-y-2'>
                                <div className='bg-gray-200 h-4 w-20'>
                                </div>
                                <div className='bg-gray-200 h-4 w-8'>
                                </div>
                            </div>
                            <div className='space-y-2'>
                                <div className='bg-gray-200 h-4 w-32'>
                                </div>
                            </div>
                            <div className='space-y-2 flex-col flex'>
                                <div className='bg-gray-200 h-4 w-20'>
                                </div>
                                <div className='bg-gray-200 h-4  w-8 self-end'>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='py-2 bg-gray-100 border-gray-200 opacity-50'>
                    <div className='w-[95%] mx-auto space-y-4 justify-between items-center'>
                        <div className='flex justify-between items-center'>
                            <div className='space-y-2'>
                                <div className='bg-gray-200 h-4 w-20'>
                                </div>
                                <div className='bg-gray-200 h-4 w-8'>
                                </div>
                            </div>
                            <div className='space-y-2'>
                                <div className='bg-gray-200 h-4 w-32'>
                                </div>
                            </div>
                            <div className='space-y-2 flex-col flex'>
                                <div className='bg-gray-200 h-4 w-20'>
                                </div>
                                <div className='bg-gray-200 h-4  w-8 self-end'>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='py-2 border-gray-200 opacity-50'>
                    <div className='w-[95%] mx-auto space-y-4 justify-between items-center'>
                        <div className='flex justify-between items-center'>
                            <div className='space-y-2'>
                                <div className='bg-gray-200 h-4 w-20'>
                                </div>
                                <div className='bg-gray-200 h-4 w-8'>
                                </div>
                            </div>
                            <div className='space-y-2'>
                                <div className='bg-gray-200 h-4 w-32'>
                                </div>
                            </div>
                            <div className='space-y-2 flex-col flex'>
                                <div className='bg-gray-200 h-4 w-20'>
                                </div>
                                <div className='bg-gray-200 h-4  w-8 self-end'>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className='py-2 bg-gray-100 border-gray-200 opacity-50'>
                    <div className='w-[95%] mx-auto space-y-4 justify-between items-center'>
                        <div className='flex justify-between items-center'>
                            <div className='space-y-2'>
                                <div className='bg-gray-200 h-4 w-20'>
                                </div>
                                <div className='bg-gray-200 h-4 w-8'>
                                </div>
                            </div>
                            <div className='space-y-2'>
                                <div className='bg-gray-200 h-4 w-32'>
                                </div>
                            </div>
                            <div className='space-y-2 flex-col flex'>
                                <div className='bg-gray-200 h-4 w-20'>
                                </div>
                                <div className='bg-gray-200 h-4  w-8 self-end'>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </>
    )
}

export default RecentTransacton;